import { NAV_PATH } from '@/router/constants';
import { Link } from 'react-router';

const ThirdContent = () => {
	return (
		<section className="sub-content cont3">
			<div className="sub-inner">
				<strong className="title">스텔라만의 차별화 서비스</strong>
				<ul className="different-service">
					<li className="different-service-item">
						<figure className="img-box1"></figure>
						<div className="cont-box">
							<p className="title">거래처 상세 신용정보 관리</p>
							<ul className="check-point">
								<li>
									국내 최대 신용정보보유사인 <span className="font-bold">나이스평가정보와</span>의 제휴를 통해 다양한
									기업정보 제공<span className="color-primary">(업계 유일)</span>
								</li>
								<li>
									약 900만 국내 기업에 대한 요약 정보 및
									<span className="font-bold">경영진, 신용등급, 대표자정보, 재무정보</span> 등 제공
								</li>
								<li>
									국내기업 <span className="font-bold">신용평가 22단계 정보</span> 및 상세매출/자산/부채/자본 등 최신
									주요 재무정보 제공
								</li>
							</ul>
						</div>
					</li>
					<li className="different-service-item">
						<figure className="img-box2"></figure>
						<div className="cont-box">
							<p className="title">삼일 Digital Transformation</p>
							<ul className="check-point">
								<li>
									Stella 기반의 <span className="font-bold">맞춤형 자동화 프로그램 구축/컨설팅</span> (예: 맞춤형 BI
									개발, 원가관리 플랫폼)
								</li>
								<li>
									삼일 Digital Product 연계를 통한 <span className="font-bold">Digital Transformation</span> (예:
									공시자동화 플랫폼)
								</li>
							</ul>
						</div>
					</li>
					<li className="different-service-item">
						<figure className="img-box3"></figure>
						<div className="cont-box">
							<p className="title">스타트업 통합경영지원서비스</p>
							<ul className="check-point">
								<li>
									국내 최대 회계법인의 스타트업 성장을 위한 <span className="font-bold">통합경영지원서비스</span> 제공
								</li>
								<li>
									Stella 기반 스타트업의 <span className="font-bold">결산,세무,급여 관리 서비스 제공</span>
								</li>
								<li>
									스타트업을 위한 <span className="font-bold">Virtual CFO 및 경영관리팀 역할 수행</span>
								</li>
							</ul>
						</div>
					</li>
					<li className="different-service-item link b2b">
						<p className="title">
							<span className="blind">B2B 수발주 서비스</span>
						</p>
						<Link to={`${NAV_PATH.FUNCTION.MAIN}#b2b`} className="text-link">
							자세히보기
						</Link>
					</li>
					<li className="different-service-item link appr">
						<p className="title">
							<span className="blind">전자결재</span>
						</p>
						<Link to={`${NAV_PATH.FUNCTION.MAIN}#e-approval`} className="text-link">
							자세히보기
						</Link>
					</li>
				</ul>
			</div>
		</section>
	);
};

export default ThirdContent;
